import React from 'react'

import EditPackageUnitForm from '../../modules/PackageUnit/components/EditPackageUnitForm'
export default function EditPackageUnitPage() {
  return <EditPackageUnitForm />
}
